import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { services } from "@/data/services";
import { useLang } from "@/i18n/LanguageContext";

export const ServicesGrid = () => {
  const { t, lang } = useLang();
  return (
    <section id="leistungen" className="py-20 md:py-24 bg-secondary/40">
      <div className="container">
        <div className="max-w-2xl mb-12 md:mb-16">
          <span className="text-accent font-semibold uppercase tracking-widest text-sm">{t("section.services.kicker")}</span>
          <h2 className="font-display text-4xl md:text-6xl text-primary mt-3 mb-4">{t("section.services.title")}</h2>
          <p className="text-muted-foreground text-lg">{t("section.services.subtitle")}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((s) => {
            const Icon = (Icons as any)[s.icon] ?? Icons.KeyRound;
            return (
              <Link
                key={s.slug}
                to={`/leistungen/${s.slug}`}
                className="group relative bg-card border border-border rounded-2xl p-6 shadow-card-soft hover:shadow-elegant hover:-translate-y-1 transition-smooth overflow-hidden"
              >
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-accent opacity-0 group-hover:opacity-10 blur-2xl rounded-full transition-smooth" />
                <div className="relative">
                  <div className="inline-flex w-12 h-12 rounded-xl bg-primary text-primary-foreground items-center justify-center mb-4 group-hover:bg-gradient-accent group-hover:text-accent-foreground transition-smooth">
                    <Icon className="w-6 h-6" />
                  </div>
                  <h3 className="font-display text-xl text-primary mb-2 tracking-wide">
                    {lang === "de" ? s.titleDe : s.titleEn}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed mb-3">
                    {lang === "de" ? s.shortDe : s.shortEn}
                  </p>
                  {s.priceFrom > 0 && (
                    <div className="text-sm font-semibold text-accent">{t("common.priceFrom")} {s.priceFrom} €</div>
                  )}
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};